import React from 'react';

import { Empty } from 'components';
import { ReactComponent as Error } from 'assets/svg/mapping-not-found.svg';

export const UploadBDXError = ({ title, text, fullScreen }) => <Empty fullScreen={fullScreen} title={title} text={text} icon={<Error />} />;
